var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8989 7.10293L7.10391 10.8979C6.61641 10.4104 6.31641 9.74293 6.31641 9.00043C6.31641 7.51543 7.51641 6.31543 9.00141 6.31543C9.74391 6.31543 10.4114 6.61543 10.8989 7.10293Z",
    stroke: "currentColor",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3639 4.32785C12.0514 3.33785 10.5514 2.79785 8.99891 2.79785C6.35141 2.79785 3.88391 4.35785 2.16641 7.05785C1.49141 8.11535 1.49141 9.89285 2.16641 10.9504C2.75891 11.8804 3.44891 12.6829 4.19891 13.3279",
    stroke: "currentColor",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.31641 14.6473C7.17141 15.0073 8.07891 15.2023 9.00141 15.2023C11.6489 15.2023 14.1164 13.6423 15.8339 10.9423C16.5089 9.88477 16.5089 8.10727 15.8339 7.04977C15.5864 6.65977 15.3164 6.29227 15.0389 5.94727",
    stroke: "currentColor",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6306 9.52539C11.4356 10.5829 10.5731 11.4454 9.51562 11.6404",
    stroke: "currentColor",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1025 10.8975L1.5 16.5",
    stroke: "currentColor",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5009 1.5L10.8984 7.1025",
    stroke: "currentColor",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSlash);
export default __webpack_public_path__ + "static/media/eye-slash.918e6d01034556ffe457d151bdb9e732.svg";
export { ForwardRef as ReactComponent };